import React from 'react';

export const ChartSvg = () => (
  <svg
    width="25"
    height="22"
    viewBox="0 0 25 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.9 12.1111L9.2 5.44444L16.9 11L23.5 1M5.9 12.1111H1.5M5.9 12.1111L16.9 17.6667L23.5 13.2222M1.5 21L3.9706 16.0089"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
